import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserCertificationViewModel } from 'src/app/_models/generatedModels';
import { UserService } from 'src/app/_services/generatedServices';
import { AddUserCertificationModalComponent } from './add-user-certification-modal.component';

@Component({
  selector: 'bxl-user-certifications',
  templateUrl: 'user-certifications.component.html',
})
export class UserCertificationsComponent implements OnInit {
  initialized = false;
  certifications: UserCertificationViewModel[];

  constructor(private user: UserService, private modalService:NgbModal) {}

  ngOnInit(): void {
   this.getData();
  }

  add() {
    const modalRef = this.modalService.open(AddUserCertificationModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.certifications = this.certifications;
    modalRef.result.then(
      (result) => {
        this.getData();
      },
      (reason) => {
        //this.getData();
      }
    );
  }

  edit(certification: UserCertificationViewModel) {
    const modalRef = this.modalService.open(AddUserCertificationModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.certifications = this.certifications;
    modalRef.componentInstance.certification = certification;
    modalRef.result.then(
      (result) => {
        this.getData();
      },
      (reason) => {
        //this.getData();
      }
    );
  }

  getData() {
    this.user.getCertifications().subscribe((certifications) => {
      this.certifications = certifications;
      this.initialized = true;
    });
  }
}
